__turbopack_context__.v({
  "extraInfoText": "QeBxLG_extraInfoText",
  "headerWrapper": "QeBxLG_headerWrapper",
  "icon": "QeBxLG_icon",
  "itemWrapper": "QeBxLG_itemWrapper",
  "stars": "QeBxLG_stars",
  "title": "QeBxLG_title",
  "wrapper": "QeBxLG_wrapper",
});
